import {Component, Input, OnInit} from '@angular/core';

import {PersonDataDTO, PersonModelMetadataDTO} from '../sdconnect.model';
import {SdconnectService} from '../sdconnect.service';

@Component({
  selector: 'gp-sdc-person-data-card',
  templateUrl: './sdc-person-data-card.component.html',
  styleUrls: ['./sdc-person-data-card.component.scss']
})
export class SdcPersonDataCardComponent implements OnInit {

  @Input()
  public metadata: PersonModelMetadataDTO;

  @Input()
  public data: PersonDataDTO[];

  @Input()
  public expandAll: boolean = false;

  public standardFields: string[];
  public additionalFields: string[];
  public dated: boolean;
  public hasError: boolean;

  ngOnInit() {
    this.standardFields = SdconnectService.standardFields(this.metadata);
    this.additionalFields = SdconnectService.additionalFields(this.metadata, this.data);
    this.dated = SdconnectService.entityIsDated(this.metadata);
    this.hasError = SdconnectService.dataHasError(this.data);
  }

}
